export const LOCK_USER_WHILE_LOGIN = `LOCK_USER_WHILE_LOGIN`;
